var _path, _path2, _path3, _path4, _path5, _ellipse, _ellipse2, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOcReview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 582,
    height: 518,
    viewBox: "0 0 582 518",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.784 393.5C124.184 383.5 135.118 403.667 137.784 415C168.984 398.6 183.118 327.833 186.284 294.5C221.884 323.7 266.118 306.667 283.784 294.5C328.072 264 317.284 231.125 289.784 210.5C273.784 198.5 268.118 186.167 265.284 177C257.451 189.167 250.784 210.5 229.784 222.5C219.365 228.454 187.284 229.071 170.284 233C80.2842 253.8 87.1176 348.667 101.784 393.5Z",
    fill: "#223B41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M104.284 389.5C97.9508 401.333 91.5846 431.5 122.785 441.5C125.451 453.5 139.584 479.9 174.784 489.5C218.784 501.5 250.284 497.5 265.784 486C281.284 474.5 301.784 443.5 303.784 414",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M286.285 413.5L308.785 412C312.785 408.5 320.785 394.5 305.285 390.5C299.618 389.5 287.085 385.5 282.285 377.5",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M282.285 294C285.451 297.833 291.285 308 289.285 318",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M207.285 359C208.451 356.167 212.085 349.5 217.285 345.5",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 245.785,
    cy: 374,
    rx: 4,
    ry: 6,
    fill: "#223B41"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 302.785,
    cy: 348,
    rx: 4,
    ry: 6,
    fill: "#223B41"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M260.285 377.5C260.285 394.476 248.717 407.5 235.285 407.5C221.853 407.5 210.285 394.476 210.285 377.5C210.285 360.524 221.853 347.5 235.285 347.5C248.717 347.5 260.285 360.524 260.285 377.5Z",
    stroke: "#223B41",
    strokeWidth: 5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M312.285 350C312.285 358.348 309.744 365.809 305.755 371.127C301.767 376.445 296.449 379.5 290.785 379.5C285.121 379.5 279.802 376.445 275.814 371.127C271.826 365.809 269.285 358.348 269.285 350C269.285 341.652 271.826 334.191 275.814 328.873C279.802 323.555 285.121 320.5 290.785 320.5C296.449 320.5 301.767 323.555 305.755 328.873C309.744 334.191 312.285 341.652 312.285 350Z",
    stroke: "#223B41",
    strokeWidth: 5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M257.285 362L269.285 355.5",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M271.285 321C272.618 318.167 276.685 312.6 282.285 313",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M165.785 379L209.785 380.5",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M119.284 408.5C117.451 411.333 114.884 418 119.284 422",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M229.285 431.5C224.618 432.667 216.285 439 220.285 455",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M236.785 448C248.618 446.624 273.985 441.497 280.785 432",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M235.785 448.5C246.951 457.667 271.585 467.4 280.785 433",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M144.785 474C140.951 479.167 135.985 491.3 146.785 498.5C157.585 505.7 176.284 511.833 184.284 514C192.784 516.5 210.084 514.5 205.284 496.5",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M292.785 480C300.118 476 314.185 463.3 311.785 444.5",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M413.021 414.5C405.021 424 367.521 428.5 365.521 428.5L389.025 396.804C379.525 386.804 367.425 358.804 395.025 326.804C422.625 294.804 478.858 300.471 503.525 307.304C523.858 314.971 556.425 341.204 524.025 384.804C491.625 428.404 431.521 428.5 413.021 414.5Z",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M411.021 347L440.521 342",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M415.521 367.5L493.021 355",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M424.021 390L466.021 384.5",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3853 212.145C21.8853 217.592 45.3853 199.645 57.3853 176.145C64.3852 184.311 81.8252 209.107 94.8852 201.645C98.3853 199.645 91.8852 174.145 81.8852 164.145C90.8852 157.145 112.885 141.645 109.385 130.645C105.922 119.759 76.3852 130.145 68.3852 137.145C70.2185 127.645 66.8853 105.378 58.8852 101.645C46.8852 96.0445 40.8852 128.311 39.3852 145.145C32.8852 146.645 20.3851 149.145 5.38519 155.645C-11.2971 162.874 15.0519 171.478 28.3852 172.145C24.8853 178.645 9.38525 202.46 17.3853 212.145Z",
    fill: "#223B41"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M140.771 160.506C145.934 165.33 166.934 144.513 175.816 119.666C183.807 126.866 204.287 149.216 216.281 140.138C219.495 137.705 209.773 113.251 198.571 104.618C206.598 96.5204 226.424 78.3229 221.54 67.8635C216.707 57.5127 188.749 71.6066 181.715 79.5762C182.313 69.9195 176.147 48.2655 167.733 45.5907C155.114 41.5784 153.308 74.3486 153.983 91.2351C147.729 93.5576 135.654 97.6426 121.613 106.016C105.998 115.328 133.234 120.476 146.542 119.424C143.906 126.32 131.594 151.93 140.771 160.506Z",
    fill: "#223B41"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M238.068 111.919C241.042 118.329 268.321 106.917 285.88 87.2209C290.584 96.8939 301.177 125.297 315.701 121.385C319.593 120.337 319.762 94.0217 312.62 81.8155C323.099 77.3225 348.307 67.8983 347.706 56.3704C347.112 44.9622 315.908 47.5308 306.397 52.277C310.576 43.5508 312.989 21.1659 306.195 15.5284C296.004 7.07239 282.029 36.7684 276.316 52.6733C269.648 52.4786 256.922 51.732 240.765 54.2221C222.796 56.9915 246.108 71.9871 258.838 76.0082C253.806 81.4102 232.781 100.525 238.068 111.919Z",
    fill: "#223B41"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M344.068 143.919C347.042 150.329 374.321 138.917 391.88 119.221C396.584 128.894 407.177 157.297 421.701 153.385C425.593 152.337 425.762 126.022 418.62 113.815C429.099 109.322 454.307 99.8983 453.706 88.3704C453.112 76.9622 421.908 79.5308 412.397 84.277C416.576 75.5508 418.989 53.1659 412.195 47.5284C402.004 39.0724 388.029 68.7684 382.316 84.6733C375.648 84.4786 362.922 83.732 346.765 86.2221C328.796 88.9915 352.108 103.987 364.838 108.008C359.806 113.41 338.781 132.525 344.068 143.919Z",
    fill: "#223B41"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M441.82 177.071C442.392 184.113 471.934 182.851 495.226 170.452C496.291 181.156 496.395 211.47 511.375 212.828C515.39 213.192 524.659 188.563 522.184 174.639C533.571 174.052 560.482 173.937 563.91 162.914C567.302 152.006 537.139 143.613 526.572 144.772C533.514 138.033 543.528 117.868 539.105 110.227C532.472 98.7653 509.081 121.787 498.214 134.73C492.026 132.239 480.346 127.133 464.326 123.875C446.509 120.252 463.188 142.391 473.738 150.571C467.148 153.897 440.805 164.551 441.82 177.071Z",
    fill: "#223B41"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOcReview);
export default __webpack_public_path__ + "static/media/oc-review.d06fa5b984e28246e1d2eb0680408b94.svg";
export { ForwardRef as ReactComponent };